module.exports = __webpack_public_path__ + "img/Group 4.c1ec4cd7.png";